export enum AdminSalesReportType {
  singleDay = 'singleDay',
  weekToDate = 'weekToDate',
  monthToDate = 'monthToDate',
  yearToDate = 'yearToDate',
  custom = 'custom',
  fourteenDays = 'fourteenDays',
  lastWeek = 'lastWeek',
  lastTwoWeeks = 'lastTwoWeeks'
}

export enum AdminSalesReportCompletedType {
  NotSet = 'NotSet',
  Manual = 'Manual',
  Protractor = 'Protractor',
  Tekmetric = 'Tekmetric',
  SimplyGenius = 'SimplyGenius',
  ShopWare = 'ShopWare',
  Motor = 'Motor'
}
